module.exports = __webpack_public_path__ + "518b4f04947640ce911b62118abd739c.svg";